import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SAKA } from '@store/models';
import { NotificationsService } from '../../../store';
import { NavigationService } from '../../../core/navigation.service';

@Component({
    selector: 'app-sa-ka',
    template: `
    <app-sa-ka-ui
        [sakas]="sakas$ | async"
        (caseClick)="caseClick($event)"
        (dismiss)="dismiss()"
    ></app-sa-ka-ui>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SAKAContainer {

    sakas$ = this.notificationsService.getSAKA();

    constructor(
        public activeModal: NgbActiveModal,
        public notificationsService: NotificationsService,
        private navigationService: NavigationService
    ) {}

    async caseClick(sag: SAKA) {
        this.activeModal.close();
        await this.navigationService.openCase(sag.kid?.toString(), sag.pid?.toString(), sag.v2RegnskabsaarKundeId, sag.yid);
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
